<template>
	<div class="drawer">
		<el-drawer
		v-if="msg.careId"
		size="80%"
		title="编辑寄养"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="6">
						<span class="label">顾客：</span>
						<span class="value">{{msg.memberName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">手机号：</span>
						<span class="value">{{msg.memberMobile}}</span>
					</el-col>
					<!-- <el-col :span="6">
						<span class="label">支付类型：</span>
						<span class="value">{{msg.depositType===1?'押金':'余额'}}</span>
					</el-col> -->
				</el-row>
				<!-- <el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="6">
						<span class="label">押金(余额)：</span>
						<span class="value">{{msg.deposit}} 元</span>
					</el-col>
					<el-col :span="6">
						<span class="label">总寄养费：</span>
						<span class="value">{{allMoney}} 元</span>
					</el-col>
					<el-col :span="6">
						<span class="label">是否欠费：</span>
						<span class="value">
							{{$public.jian(msg.deposit,allMoney)?'未欠费':'已欠费'}}
						</span>
					</el-col>
				</el-row> -->
			</div>
			<div style="border-top:1px solid #eee;padding:30px 0;" v-for="(item,index) in msg.pets" :key="index">
				<el-row style="padding:0px 20px 0;float: none;font-size: 20px;">
					<el-col :span="6">
						<span class="label">宠物昵称：</span>
						<span class="value">{{item.petName}}</span>
					</el-col>
					<!-- <el-col :span="18">
						<span class="label">笼子：</span>
						<span class="value">
							<span v-for="(cagesItem,cagesIndex) in item.cages" :key="cagesIndex">{{cagesItem.name+' '}}</span>
						</span>
					</el-col> -->
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="6">
						<span class="label">种类：</span>
						<span class="value">{{item.petType}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">品种：</span>
						<span class="value">{{item.typeName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">性别：</span>
						<span class="value">{{item.sex}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">体重：</span>
						<span class="value">{{item.weight}} kg</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="6">
						<span class="label">开始时间：</span>
						<span class="value">{{$public.FTime(item.beginDate,'YYYY-MM-DD HH:mm:ss')}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">结束时间：</span>
						<span class="value">
							<el-date-picker
								style="width:180px;"
								v-model="endTime"
								@change="changeEndTime"
								type="datetime"
								placeholder="请选择"
								:picker-options="{disabledDate(time) {return oldEndTime.getTime() > time.getTime()}}"
								size="mini">
							</el-date-picker>
						</span>
					</el-col>
					<el-col :span="6">
						<span class="label">活动：</span>
						<span class="value">{{item.activityName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">已产生寄养费：</span>
						<span class="value">{{item.totalMoney}} 元</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="12">
						<span class="label">备注：</span>
						<span class="value">{{item.remark}}</span>
					</el-col>
				</el-row>
			</div>
			<div style="border-top:1px solid #eee;padding:0px 0;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="6">
						<span class="label">经办人：</span>
						<span class="value">
							<span v-for="item in msg.serviceMan" :key="item">{{item+' '}}</span>
						</span>
					</el-col>
					<el-col :span="6">
						<span class="label">备注：</span>
						<span class="value">{{msg.remark}}</span>
					</el-col>
				</el-row>
			</div>
			<div style="padding:100px 60px 0;">
				<el-button type="primary" style="width:200px;" @click="submit">修改</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				msg:{},
				allMoney:0,
				// 结束时间
				endTime:null,
				oldEndTime:null,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{this.drawerStatus=true})
			this.getGoodsMsg(this.curItem.recordId)
		},
		methods: {
			handleClose(){
				this.$emit('close')
			},
			// 改变时间
			changeEndTime(){
				console.log('changeEndTime')
			},
			// submit
			submit(){
				if(!this.endTime){
					this.$message({
						message: '结束时间有误',
						type: 'error'
					});
					return ;
				}
				let loading = this.$loading()
				this.$http.post('/api/FosterCare/UpdatePet', {
					"recordId": this.msg.pets[0].recordId,
					"activityId": this.msg.pets[0].activityId,
					"activityName": this.msg.pets[0].activityName,
					"activityType": this.msg.pets[0].activityType,
					"activityDiscounts": this.msg.pets[0].activityDiscounts,
					"endDate": this.endTime.getTime().toString().substr(0,10)
				}).then(res=>{
					loading.close();
					if(res.code===0){
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit('close')
					}
				})
			},
			// 获取商品信息
			getGoodsMsg(recordId) {
				let loading = this.$loading()
				this.$http.get('/api/FosterCare/Detail/Pet', {
					recordId: recordId
				}).then(res=>{
					loading.close();
					if(res.code===0){
						this.msg = res.data;
						this.allMoney = 0;
						this.endTime = new Date(this.msg.pets[0].endDate*1000)
						this.oldEndTime = new Date(this.msg.pets[0].endDate*1000)
						for(let i=0;i<this.msg.pets.length;i++){
							let item = this.msg.pets[i];
							this.allMoney = this.$public.jia(this.allMoney,item.totalMoney)
						}
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:150px;text-align: right;
			}
		}
		
	}
	
</style>
